import { render, staticRenderFns } from "./Originals.vue?vue&type=template&id=214d424d&"
import script from "./Originals.vue?vue&type=script&lang=js&"
export * from "./Originals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports